module.exports = __webpack_public_path__ + "img/icon.71d3614f.svg";